// Integrations
import { type GlobalEvents, type IGlobalEventContext } from './constants';
import { BranchAnalytics } from '@/analytics/integrations/branch';
import { FacebookAnalytics } from '@/analytics/integrations/facebook';
import { GoogleAnalytics } from '@/analytics/integrations/google';

export const pageViewEventHandler = (page?: string) => {
  const path = page || window.location.pathname;

  // Google
  GoogleAnalytics.pageView(path);

  // Branch
  BranchAnalytics.pageView();

  // Facebook
  FacebookAnalytics.pageView();

  // React Native
  if (typeof window !== 'undefined' && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(path);
  }
};

export const genericEventHandler = (
  eventName: GlobalEvents,
  eventContext: IGlobalEventContext = {},
) => {
  // Google
  GoogleAnalytics.genericEvent(eventName, eventContext);

  // Branch
  BranchAnalytics.genericEvent(eventName, eventContext);
};
